<template>
  <div>
    <h1>All Lists</h1>
    <Checklists :filter=true />
  </div>
</template>

<script>
import Checklists from '@/components/checklists.vue'
import Checklist from '@/components/checklist_detail.vue'

export default {
  name: 'AllChecklists',
  components: {
    Checklists,
    Checklist
  }
}
</script>
